import * as React from "react";
import {sortBy} from "lodash";
import PaperLayout from "components/PaperLayout/PaperLayout";
import {DataBaseComponent, DataBaseComponentState} from "components/DataBaseComponent";
import repository from "client/repository";
import {FeatureToggle, FeatureToggleScope} from "client/resources/featureFlagsResource";
import FeatureFlagsDataTable from "./FeatureFlagsDataTable";
import {HostedInstanceLookupResource} from "../../client/resources/hostedInstanceLookupResource";
import {ReefResource} from "../../client/resources/reefResource";
import OverflowMenu from "components/Menu/OverflowMenu";
import ActionList from "components/ActionList/ActionList";
import {EnvironmentName} from "client/resources/environmentName";

interface State extends DataBaseComponentState {
    featureFlags?: FeatureToggle[];
    instances?: HostedInstanceLookupResource[];
    reefs?: ReefResource[];
    newFeatureFlagName?: string;
    environment?: string;
}

class FeatureFlags extends DataBaseComponent<{}, State> {
    constructor(props: {}) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        this.loadData();
    }

    private async loadData() {
        return this.doBusyTask(async () => {
            const featureFlags = await repository.Configuration.getFeatureFlags();
            const reefs = await repository.Reefs.list();
            const instances = await repository.HostedInstances.lookup();
            const appInfo = await repository.Configuration.getAppInfo();

            this.setState({
                featureFlags: sortBy(featureFlags.Features, f => f.Name.toLowerCase()),
                reefs,
                instances,
                environment: appInfo.Environment,
            });
        });
    }

    private editFeatureFlag = (featureFlag: FeatureToggle): Promise<any> => {
        return this.doBusyTask(async () => {
            await repository.Configuration.editFeatureFlag(featureFlag.Id, {Enabled: featureFlag.IsEnabled});
            await this.loadData();
        });
    }
    
    private onFeatureFlagSave = async (): Promise<boolean> => {
        return this.doBusyTask(async () => {
            await this.loadData();
        });
    }

    private enableE2EFeatureFlags = () => {
        this.doBusyTask(async () => {
            await repository.Configuration.enableE2EFeatureFlags();
            await this.loadData();
        });
    }

    private getOverflowMenu() {
        return [<OverflowMenu menuItems={[
            (this.state.environment === EnvironmentName.Development || this.state.environment === EnvironmentName.Test)
                && OverflowMenu.item("Enable E2E Feature Flags", this.enableE2EFeatureFlags)
        ]}/>];
    }

    render() {
        return <PaperLayout title="Portal Feature Flags"
                            busy={this.state.busy}
                            errors={this.state.errors}
                            fullWidth={false}
                            sectionControl={<ActionList actions={this.getOverflowMenu()}/>}>
            {this.state.featureFlags &&
            <FeatureFlagsDataTable
                featureFlags={this.state.featureFlags}
                editFeatureFlag={this.editFeatureFlag}
                instances={this.state.instances}
                reefs={this.state.reefs}
                onFeatureFlagSave={this.onFeatureFlagSave}
            />}
        </PaperLayout>;
    }
}

export default FeatureFlags;